import './FilterButton.css';
import { FilterIcon } from '../../../../assets/FilterIcon';
import { tourAnchor, type TourAnchorId } from '../../../tours/tourAnchors';

interface FilterButtonProps {
  activeFilterCount: number;
  onClick: () => void;
  /**
   * Tour anchor for this button, when the page that renders it has a tour pointing at it.
   * A prop rather than a hard-coded id because the same button also sits inside the calls
   * list builder modal, and a players step must not spotlight that one.
   */
  anchor?: TourAnchorId;
}

export const FilterButton = ({ activeFilterCount, onClick, anchor }: FilterButtonProps) => {
  const isActive = activeFilterCount > 0;
  const ariaLabel = isActive ? `Filter (${activeFilterCount} active)` : 'Filter';

  return (
    <button
      type="button"
      className={`filter-button ${isActive ? 'filter-button--active' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
      {...(anchor ? tourAnchor(anchor) : {})}
    >
      <FilterIcon className="filter-button__icon" />
      <span className="filter-button__text">Filter</span>
      {activeFilterCount > 0 && (
        <span className="filter-button__badge">
          {activeFilterCount > 99 ? '99+' : activeFilterCount}
        </span>
      )}
    </button>
  );
};
